import DescriptionIcon from '@mui/icons-material/Description';
import { Alert, Paper, Stack } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { CollectionSectionHeader } from './CollectionSectionHeader';
import { CollectionStatusChip } from './CollectionStatusChip';
type Props = {
  status: 'success' | 'error' | 'warning';
  uploadCount: number;
};

export const CollectionFileStatus = ({ status, uploadCount }: Props) => {
  const { t } = useTranslation();

  return (
    <Paper variant='outlined' sx={{ p: 1.5, borderRadius: 1 }}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <CollectionSectionHeader
          icon={
            <DescriptionIcon
              sx={(theme) => ({ color: theme.vars.palette.text.secondary })}
            />
          }
          title={t('Collection JSON File')}
        />

        {status === 'error' && (
          <CollectionStatusChip status='error' label={t('Missing')} />
        )}
        {status === 'warning' && (
          <CollectionStatusChip
            status='warning'
            label={t('{{count}} files', { count: uploadCount })}
          />
        )}
        {status === 'success' && (
          <CollectionStatusChip status='success' label={t('Present')} />
        )}
      </Stack>

      {status === 'error' && (
        <Alert severity='error' sx={{ mt: 1 }}>
          {t('Collection JSON file is missing.')}
        </Alert>
      )}

      {status === 'warning' && (
        <Alert severity='warning' sx={{ mt: 1 }}>
          {t(
            'Multiple Collection JSON files found. Only one file should be present.'
          )}
        </Alert>
      )}
    </Paper>
  );
};
